module.exports = __webpack_public_path__ + "static/img/hkj6.8ba25f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj6.jpg
// module id = 0fC8
// module chunks = 0